import script from "./WordPressDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WordPressDetail.vue?vue&type=script&setup=true&lang=js"

import "./WordPressDetail.vue?vue&type=style&index=0&id=513f2c1a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-513f2c1a"]])

export default __exports__